<template>
  <div class="deal-intro" :class="{ 'hover-deal': hoverable }">
    <div class="deal-inner">
      <div class="media-block">
        <img
          class="contain-image padding"
          :src="product?.introImage"
          :alt="
            translateUcFirst('justopp.deals.productImageAlt', {
              name: product?.name,
            })
          " />
      </div>
      <div class="brand-block flex-row flex-middle">
        <div class="brand-image-container flex-row flex-middle flex-center">
          <img
            class="contain-image"
            :src="brand.logoImage"
            :alt="
              translateUcFirst('justopp.deals.brandLogoAlt', {
                name: brand.name,
              })
            " />
        </div>
        <!--
        <div class="brand-name-container flex-column flex-start">
          <span class="brand-name">{{ product?.brandName }}</span>
        </div> -->
      </div>
      <div class="product-block">
        <div class="product-name">
          <span>{{ product?.name }}</span>
        </div>
        <div v-if="product?.shortIntroText" class="product-description">
          <span>{{ product?.shortIntroText }}</span>
        </div>
      </div>
      <div class="main-blocks-separator"></div>
      <div class="info-separator"></div>
      <div class="details-block">
        <div v-if="product?.code" class="detail">
          <div class="detail__label">
            {{ translateUcFirst("justopp.deals.productCode") }}:
          </div>
          <div class="detail__data">
            {{ product?.code }}
          </div>
        </div>
        <!--
        <div class="detail">
          <div class="detail__label">
            {{ translateUcFirst("justopp.deals.quantity") }}:
          </div>
          <div class="detail__data">
            {{ product?.JustoppDealProductType?.maximumQuantity }}
          </div>
        </div>-->
        <div class="detail">
          <div class="detail__label">
            {{ translateUcFirst("justopp.deals.minimumQuantity") }}:
          </div>
          <div class="detail__data">
            {{ product?.JustoppDealProductType?.minimumQuantity }}
          </div>
        </div>
        <!--
        <div class="detail">
          <div class="detail__label">
            {{ translateUcFirst("justopp.deals.partialPurchase") }}:
          </div>
          <div class="detail__data">
            <icon
              :icon="partialSellingAllowed ? 'check' : 'x'"
              :theme="partialSellingAllowed ? 'success' : 'error'"></icon>
          </div>
        </div>
        -->
      </div>
      <div class="info-separator"></div>
      <div class="cta-block relative z-level-2" style="pointer-events: none">
        <div class="deal-actions flex-column flex-stretch gap-m">
          <form-button
            :disabled="hasEnded"
            class="deal-action-button"
            inner-class="deal-action-button flex width-expand"
            icon="cart"
            text="justopp.deals.makeADealCta"
            theme="lead">
          </form-button>
          <!--
          <form-button
            class="deal-action-button"
            inner-class=" deal-action-button flex width-expand"
            icon="clipboard-check"
            theme="alt">
            <template #text>
              <div class="button-text flex width-expand">
                <span class="flex-between width-expand">
                  <span>{{ translate("justopp.deals.bidFromCta") }} </span>
                  <strong
                    v-if="
                      product?.AuctionProductType?.startingPrice && product?.currency
                    ">
                    {{
                      translateNumber(
                        product?.AuctionProductType?.startingPrice,
                        "currency",
                        { currency: product?.currency }
                      )
                    }}
                  </strong>
                </span>
              </div>
            </template>
          </form-button>
          <form-button
            class="deal-action-button"
            inner-class="flex width-expand"
            icon="check"
            theme="success">
            <template #text>
              <div class="button-text flex width-expand">
                <span class="flex-between width-expand">
                  <span>{{ translate("justopp.deals.buyNowCta") }} </span>
                  <strong v-if="product?.price && product?.currency">
                    {{
                      translateNumber(product?.price, "currency", {
                        currency: product?.currency,
                      })
                    }}
                  </strong>
                </span>
              </div>
            </template>
          </form-button>
          -->
        </div>
      </div>
    </div>
    <div class="expiry-block">
      <span>
        <icon-text icon="calendar">
          <span class="expiry-label">{{
            translateUcFirst("justopp.deals.dealExpires")
          }}</span>
          <span>&nbsp</span>
          <span
            v-if="product?.AuctionProductType?.endDateTime && !hasEnded"
            class="expiry-value">
            {{ translateDate(product?.AuctionProductType?.endDateTime, "dateWithTime") }}
          </span>
          <span
            v-if="product?.AuctionProductType?.endDateTime && hasEnded"
            class="expiry-value">
            {{ translate("justopp.deals.dealHasExpired") }}
          </span>
          <span v-if="!product?.AuctionProductType?.endDateTime" class="expiry-value">
            {{ translate("justopp.deals.expiryNotSet") }}
          </span>
        </icon-text>
      </span>
    </div>

    <saffron-link
      v-if="linkable && product?.id && !hasEnded"
      :to="{ name: 'store-deals-dealId', params: { dealId: product.id } }"
      class="deal-link absolute-cover z-level-1"></saffron-link>
    <a
      v-if="linkable && product?.id && hasEnded"
      href="#"
      style="cursor: not-allowed"
      class="deal-link absolute-cover z-level-1"
      @click.stop.prevent=""></a>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: {},
    },
    linkable: {
      type: Boolean,
      default: true,
    },
    hoverable: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {};
  },
  computed: {
    hasEnded() {
      let endDate = this.product?.AuctionProductType?.endDateTime;

      if (!endDate) {
        return false;
      }

      let endTime = new Date(endDate).getTime();
      let now = new Date().getTime();
      let result = now > endTime;

      return result;
    },
    partialSellingAllowed() {
      let data = this?.product?.JustoppDealProductType;
      return data?.minimumQuantity < data?.maximumQuantity;
    },
    brand() {
      if (!this.product) {
        return {
          name: "",
          description: {},
          logoImage: "",
        };
      }
      // if brand defined - show it, else , use product
      if (this.product.Brand && this.product.Brand.name != "") {
        return this.product.Brand;
      } else {
        return {
          name: this.product.brandName,
          description: this.product.brandInformation,
          logoImage: this.product.brandLogo,
        };
      }
    },
  },
};
</script>
<style lang="scss">
// deal intro custom typography
html body .deal-intro,
html body .deal-intro * {
  --base-font-size: 1px;
  --font-min: calc(10 * var(--base-font-size));
  --font-xs: calc(12 * var(--base-font-size));
  --font-s: calc(14 * var(--base-font-size));
  --font-m: calc(16 * var(--base-font-size));
  --font-l: calc(18 * var(--base-font-size));
  --font-xl: calc(20 * var(--base-font-size));
  --font-2xl: calc(25 * var(--base-font-size));
  --font-3xl: calc(32 * var(--base-font-size));
  --font-max: calc(38 * var(--base-font-size));
  font-size: var(--font-m);
}
</style>

<style scoped lang="scss">
.deal-intro {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  position: relative;
  width: auto;
  flex: 100%;
  min-width: 265px;
  max-width: 100%;
  color: var(--c-text);
  border-radius: var(--border-radius-s);
  box-shadow: var(--box-shadow-1);
  // overflow: hidden;
  transition: 200ms ease;
  border: 1px solid var(--c-gray-3);

  @media (max-width: 1024px) {
    min-width: 245px;
  }
}

.hover-deal {
  &:hover {
    transform: scale(1.03, 1.03);
    box-shadow: var(--box-shadow-3);
    z-index: var(--z-level-2);
    border: 1px solid var(--c-gray-3);
  }
}

.deal-inner {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  position: relative;
  height: 100%;
  border-bottom: none;
}

.main-blocks-separator {
  margin-top: auto;
}

.media-block {
  width: 100%;
  height: 200px;
}

.brand-block {
  background: var(--c-gray-1);
  border-top: 1px solid var(--c-gray-2);
  border-bottom: 1px solid var(--c-gray-2);
  overflow: hidden;
}

.brand-image-container {
  position: relative;
  height: 60px;
  // flex: 0 0 100px;
  flex: 0 0 100%;

  font-size: var(--font-s);
  padding-block: var(--margin-s);
  padding-inline: var(--margin-m);
  // border-inline-end: 1px solid var(--c-gray);
  box-shadow: var(--box-shadow-5);
}

.brand-name-container {
  padding-block: var(--margin-s);
  padding-inline: var(--margin-m);
  width: 100%;
  flex: 100%;
  display: block;
  text-align: center;
}

.brand-label {
  color: var(--c-gray-4);
}

.brand-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 100%;
  max-width: 150px;
  font-weight: 600;
  font-size: var(--font-l);
}

.product-block {
  padding: var(--margin-l) var(--margin-m) var(--margin-m) var(--margin-m);
}

.product-name {
  font-size: var(--font-xl);
  font-weight: 600;
  text-align: center;
  display: block;
  margin-bottom: var(--margin-xs);
}

.product-code {
  text-align: center;
  display: block;
  font-weight: 600;
}

.product-description {
  font-size: var(--font-s);
  opacity: 0.85;
  text-align: center;
  display: block;

  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
  text-overflow: ellipsis;
}

.info-separator {
  display: block;
  height: 1px;
  width: 50%;
  background-color: var(--c-gray-2);
  margin: var(--margin-m) auto;
}

.details-block {
  padding: 0 var(--margin-m);

  .detail {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: var(--margin-xs);

    &:last-of-type {
      margin-bottom: 0;
    }

    &__label {
      font-weight: 600;
      margin-inline-end: 1ch;
    }

    &__data {
      color: var(--c-gray-5);
    }
  }
}

.cta-block {
  padding: var(--margin-m) var(--margin-m) var(--margin-l) var(--margin-m);

  .deal-action-button {
    padding-inline-end: 1em;
    padding-inline-start: 1em;
  }
}

.expiry-block {
  position: relative;
  z-index: var(--z-level-2);
  //box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.3);
  color: var(--c-bg);
  background-color: var(--c-gray-5);
  padding: var(--margin-m);
  margin-top: auto;
  border-inline-start: 1px solid var(--c-gray-5);
  border-inline-end: 1px solid var(--c-gray-5);
  inset-inline-start: -1px;
  width: calc(100% + 2px);
  .expiry-label {
    font-weight: 600;
  }
}
</style>
